import { Pipe, PipeTransform, inject } from '@angular/core';

import { RegistreStore } from '../state/registre.store';

@Pipe({ name: 'judet' })
export class JudetPipe implements PipeTransform {
  private readonly registreStore = inject(RegistreStore);

  transform(value: number | string | null | undefined): string {
    const jud = this.registreStore.judet().filter(judet => judet.id === value);
    if (jud.length > 0) {
        return jud[0].nume;
    } else {
        return value == null ? '' : value.toString();
    }
  }

}
